import script from "./DoctorSearchbarSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorSearchbarSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./DoctorSearchbarSkeleton.vue?vue&type=style&index=0&id=466f2a8d&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466f2a8d"]])

export default __exports__